import React from "react";
import { IoCloseSharp } from "react-icons/io5";
import { motion } from "framer-motion";

import "./Model.scss";
import "../../container/Work/Work.scss";
import { urlFor } from "../../client";
import { AiFillEye, AiFillGithub } from "react-icons/ai";

// { isOpen, setIsOpen }
const Model = ({ isOpen, setIsOpen, content }) => {
  if (!isOpen) return null;
  return (
    <div className="model__container">
      <div
        className="model___parent"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        <IoCloseSharp
          onClick={() => setIsOpen(!isOpen)}
          className="model__close"
        />
        <div className="app__work-item">
          <div className="app__work-model-img app__flex">
            <img
              src={urlFor(content.imgUrl)}
              alt={content.title}
              loading="lazy"
            />

            {/* remaining card data */}
          </div>

          {/* create the div for title and description */}
          <div className="app__work-content app__flex">
            <h3 className="bold-text">{content.title}</h3>
            <p className="p-text" style={{ marginTop: 10 }}>
              {content.description}
            </p>

            {/* now render the tags */}
            <div className="app__work-tag app__flex">
              <p className="p-text">{content.tags[0]}</p>
            </div>
          </div>
          <div className="app__work-model-hover app__flex">
            {/* when you used _blank it is better to set the rel to -> noreferrer */}
            {/* here will have the links for the site or it's code */}
            <a
              href={content.projectLink}
              target="_blank"
              rel="noreferrer"
              aria-label="have a look at the site"
              onClick={(e) => e.stopPropagation()}
            >
              <motion.div
                whileInView={{ scale: [0, 1] }}
                whileHover={{ scale: [1, 0.9] }}
                transition={{ duration: 0.25 }}
                className="app__flex"
              >
                <AiFillEye />
              </motion.div>
            </a>
            {/* Second icon for the code */}
            {/* {console.log(work.codeLink)} */}
            {content.codeLink !== undefined && (
              <a
                href={content.codeLink}
                target="_blank"
                rel="noreferrer"
                aria-label="have a look at the code"
                onClick={(e) => e.stopPropagation()}
              >
                <motion.div
                  whileInView={{ scale: [0, 1] }}
                  whileHover={{ scale: [1, 0.9] }}
                  transition={{ duration: 0.25 }}
                  className="app__flex"
                >
                  <AiFillGithub />
                </motion.div>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Model;
